export default {
  common: {
    price: '{{currency}} {{amount}}',
    dateRange: '{{from}} - {{to}}',
    currencyJpy: 'JPY',
    suggestVisitingTime: '建議遊玩時長',
    searchIcon: '✦',
    zoomIn: '+',
    zoomOut: '−',
    back: '←'
  },
  home: {
    searchPlaceholder: '告訴我你想去什麼地方...',
    scale800m: '步行15分鐘 (800m)',
    scale2km: '地鐵2站以內 (2km)',
    scale5km: '地鐵5站以內 (5km)',
    nearbyCount: '共 {{count}} 個地點',
    listMode: '列表模式',
    mapMode: '地圖模式',
    exploreNearby: '探索附近',
    filterAll: '全部',
    tataGreeting: '嗨，我是tata!\n看看{{city}}還有哪些好玩的地方吧～',
    tataGreetingFallback: '你好，我是tata\n我們一起發現更多有趣的好去處吧～'
  },
  search: {
    noResults: '暫無結果',
    youMayLike: '猜你喜歡',
    whereNext: '接下來去哪？'
  },
  booking: {
    ticketInfo: '門票資訊',
    viewTicket: '查看電子票券',
    plan: '方案',
    date: '參加日期',
    participants: '參加人數',
    highlights: '亮點推薦',
    openingHours: '營業時間',
    address: '地址',
    officialSite: '官網',
    goingTo: '即將前往{{title}}',
    nextStation: '開啟下一站'
  },
  profile: {
    backToMap: '返回地圖',
    my: '我的',
    tickets: '票券',
    favourites: '收藏',
    exploreMore: '探索更多',
    viewMap: '查看地圖'
  },
  bookmarks: {
    myBookmarks: '我的收藏',
    empty: '暫無收藏'
  },
  tickets: {
    myTickets: '我的票券',
    quantity: '數量',
    viewTicket: '查看票券',
    empty: '暫無票券'
  },
  voucher: {
    scanCode: '請掃碼',
    useEticket: '點擊使用電子票券',
    ticketDetail: '票券詳情',
    notification: '具體資訊及人工換票時請點擊「票券詳情」',
    orderId: '訂單ID：{{id}}'
  },
  poi: {
    highlights: '亮點推薦',
    openingHours: '營業時間',
    address: '地址',
    officialWebsite: '官網連結',
    adultTicket: '成人門票',
    priceFrom: '{{price}} 起',
    buyTicket: '前往購票',
    viewDetails: '查看詳情',
    freeAdmission: '免費入場',
    ratingCount: '{{n}}人評分',
    star: '★',
    clock: '🕐',
    nearbyRecommend: '周邊推薦',
    recentEvents: '近期活動',
    distanceTo: '距{{name}} {{distance}}',
    aiGenerated: '此內容由AI生成',
    goingTo: '即將前往',
    categories: {
      experience: '體驗',
      nature: '自然',
      attraction: '景點',
      gourmet: '美食',
      shopping: '購物'
    }
  },
  event: {
    tag: '活動',
    period: '活動時間',
    duration: '遊玩時長',
    officialWebsite: '活動官網'
  }
};
